var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container",staticStyle:{"margin-top":"70px"}},[_c('table-leaders',{ref:"tableLeaders",attrs:{"datos":_vm.table.data,"limitSelection":_vm.table.limitSelection},on:{"setFilterTable":_vm.setFilterTable}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7311a10e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lideres/ResultadoLiderazgo/ResulParte2.vue
// module id = 1232
// module chunks = 2